"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var CircularProgress_1 = __importDefault(require("../CircularProgress"));
var IconButton_1 = __importDefault(require("../IconButton"));
var ActionButtons_1 = __importDefault(require("../ActionButtons"));
var useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        root: {
            display: 'flex',
            justifyContent: 'center',
            width: 160,
            position: 'relative',
            paddingBottom: 28,
            paddingLeft: 20,
            paddingRight: 20,
        },
        ringContainer: {
            position: 'relative',
        },
        ringContent: {
            display: 'flex',
            paddingTop: 26,
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        countDown: {
            margin: 0,
            lineHeight: 1,
        },
        controls: {
            position: 'absolute',
            bottom: 0,
            right: 0,
            left: 0,
        },
    });
});
var PomodoroTimer = function (_a) {
    var time = _a.time, mode = _a.mode, onClickPause = _a.onClickPause, onClickPlay = _a.onClickPlay, onClickReset = _a.onClickReset, _b = _a.paused, paused = _b === void 0 ? false : _b, progress = _a.progress;
    var classes = useStyles();
    var minutes = Math.floor(time / 60);
    var seconds = time % 60;
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("div", { className: classes.ringContainer },
            react_1.default.createElement(CircularProgress_1.default, { size: 120, variant: "static", thickness: 3, value: progress }),
            react_1.default.createElement("div", { className: classes.ringContent },
                react_1.default.createElement(core_1.Typography, { variant: "h4", className: classes.countDown },
                    minutes,
                    ":",
                    seconds < 10 && '0',
                    seconds),
                react_1.default.createElement(core_1.Typography, { variant: "caption" }, mode !== 'break' ? 'Focus' : 'Break'))),
        react_1.default.createElement(ActionButtons_1.default, { align: "space-between", className: classes.controls },
            react_1.default.createElement(IconButton_1.default, { onClick: onClickReset },
                react_1.default.createElement(icons_1.ReplayRounded, null)),
            paused && (react_1.default.createElement(IconButton_1.default, { onClick: onClickPlay },
                react_1.default.createElement(icons_1.PlayArrowRounded, null))),
            !paused && (react_1.default.createElement(IconButton_1.default, { onClick: onClickPause },
                react_1.default.createElement(icons_1.PauseRounded, null))))));
};
exports.default = PomodoroTimer;
//# sourceMappingURL=PomodoroTimer.js.map